import { ContactLink, SupportLink, TermsOfServiceLink, PrivacyPolicyLink, AboutLink } from "./links";


export const redirects = [
  {
    path: "/contact",
    redirect: ContactLink,
  },
  {
    path: "/support",
    redirect: SupportLink,
  },
  {
    path: "/tos",
    redirect: TermsOfServiceLink,
  },
  {
    path: "/privacy",
    redirect: PrivacyPolicyLink,
  },
  {
    path: "/about",
    redirect: AboutLink,
  },
  {
    path: "/tracker-guides/1",
    redirect: "https://support.collatracking.com/en/support/solutions/articles/103000403253-getting-to-know-your-dog-pro",
  },
  {
    path: "/tracker-guides/*",
    redirect: SupportLink,
  }
];
